const dateFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'UTC',
    month: 'short',
    day: 'numeric',
    year: 'numeric'
});
const dayMonthFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'UTC',
    month: 'short',
    day: 'numeric'
});
const dayFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'UTC',
    day: 'numeric'
});
function datestampToDate(param) {
    let [year, month, day] = param;
    return new Date(Date.UTC(year, month - 1, day));
}
function utcYear(date) {
    return date.getUTCFullYear();
}
function utcMonth(date) {
    return date.getUTCMonth();
}
function formatDateRange(from, to) {
    if (from.getTime() === to.getTime()) {
        return dateFormatter.format(from);
    }
    if (utcYear(from) !== utcYear(to)) {
        return "".concat(dateFormatter.format(from), " – ").concat(dateFormatter.format(to));
    }
    if (utcMonth(from) !== utcMonth(to)) {
        return "".concat(dayMonthFormatter.format(from), " – ").concat(dateFormatter.format(to));
    }
    return "".concat(dayMonthFormatter.format(from), " – ").concat(dayFormatter.format(to), ", ").concat(utcYear(from));
}
export function formatInvoiceLineItemPeriod(param) {
    let { from, to, proRata } = param;
    const dateRange = formatDateRange(datestampToDate(from), datestampToDate(to));
    if (proRata == null) return dateRange;
    const percent = Math.round(proRata);
    return "".concat(dateRange, " (").concat(percent, "%)");
}
